export const WIDGET_SETTINGS = {
    ICON_SHAPE: {
        CIRCLE: 'circle',
        ROUNDED_BOX: 'rounded_box',
    },
} as const;
